(function () {
  'use strict';

  class DeviceHealthCtrl {
    constructor($safetyService, $window, Authenticator, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys,
      $state, Keys, ServiceVfiltro, FactoryVfiltro, $translate, UrlService) {
      this.window = $window;
      this.safetyService = $safetyService;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.user = {};
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.state = $state;
      this.isFeatureFlagDeviceHealthPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_PAGE);
      this.isFeatureTelematicsTableEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.DEVICE_HEALTH_TELEMATICS_TABLE);
      this.isFeatureHideTitleEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ORION_HIDE_TITLE);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.urlService = UrlService;
      this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
      if (this.isFeatureHideTitleEnabled && this.queryParams.hideTitle === 'true') {
        this.hideTitle = true;
      } else {
        this.hideTitle = false;
      }
      this.authenticator.getUser()
        .then(user => {
          this.user = user;

          ServiceVfiltro.init(FactoryVfiltro.get(this.handleGetVFiltro()))
          .then((filtro) => {
            this.filtro = filtro;
            this.initializePage(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
          });
        });
    }

    handleGetVFiltro() {
      if (!this.user.isNa && this.isFeatureTelematicsTableEnabled) {
        return [
          {
            name: 'uoId',
            required: true,
            key: this.keys.uo.name,
            size: 12
          },
          {
            name: 'mainSemaphoreStatus',
            required: false,
            key: this.keys.vehicleHealthStatus.name,
            size: 6
          }
        ];
      }
      return [
        {
          name: 'uoId',
          required: true,
          key: this.keys.uo.name,
          size: 12
        },
        {
          name: 'vehiclesWithDevices',
          required: false,
          key: this.keys.vehiclesWithDevices.name,
          size: 6,
          order: 5
        },
        {
          name: 'deviceHealthStatus',
          required: false,
          key: this.keys.deviceHealthStatus.name,
          size: 6
        },
        {
          name: 'sdCardStatus',
          required: false,
          key: this.keys.sdCardStatus.name,
          size: 6
        },
        {
          name: 'cameraDiagnostics',
          required: false,
          key: this.keys.cameraDiagnostics.name,
          size: 6
        }
      ];
    }

    initializePage(filter) {
      this.safetyService.initialize()
      .then(() => this.loadPage(filter));
    }

    loadPage(filter) {
      const appName = 'safetyApp',
          componentPath = './DeviceHealthPageRoute',
          componentId = 'safety-app-device-health';

      this.safetyService
        .loadReactComponent(
          appName,
          componentPath,
          componentId,
          {user: this.user, filter: filter, hideTitle: this.hideTitle}
        );
    }
  }
  DeviceHealthCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', '$state', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$translate', 'UrlService'];
  angular.module('relatorios.deviceHealth').controller('DeviceHealthCtrl', DeviceHealthCtrl);
}());
